<template lang="pug">
div.container-fluid
	.row
		.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
			.card
				.card-header
					span.fa.fa-user.mr-2
					| Usuario
				.card-body
					.form-group(v-if="soyLider")
						label Selecciona el Usuario
						input-query(
							v-if="!registro.usuario_ID"
							input-class="form-control"
							placeholder="Buscar por nombre"
							url="gestion-horaria/php/api/query-usuarios.php"
							@selected="seleccionaUsuario($event)"
							:realtime="true"
						)
						.input-group(v-else)
							input.form-control(disabled, :value="registro.usuarioNombre")
							.input-group-append(v-if="editable")
								button.btn.btn-danger(@click="quitarUsuario")
									span.fa.fa-trash
					div(v-else)
						.input-group
							input.form-control(disabled, :value="usuario.nombre + ' ' + usuario.apellidos")
			.card.mt-3
				.card-header.bg-warning
					span.fa.fa-list.mr-2
					| Histórico de modificaciones
				table.table.table-striped.m-0(v-if="historico.length > 0")
					tbody
						tr(
							v-for="item in historico"
							:key="item.ID_registro"
							:class="(registro.ID_registro === item.ID_registro) ? 'bg-info text-white' : ''"
							style="cursor:pointer;"
							@click="$router.push('/main/horas-extra/editor/' + item.ID_registro)")
							td {{item.fecha_registro}}
							td {{item.autorNombre}}
		.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
			.card
				.card-header
					span.fa.fa-search.mr-2
					| Detalles
				.card-body
					.row
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Fecha del registro
								datepicker(
									v-if="editable"
									placeholder="Selecciona"
									:bootstrap-styling="true"
									:monday-first="true"
									:language="$dateLang"
									v-model="registro.fecha"
								)
								input.form-control(v-if="!editable", :value="registro.fecha", disabled)
						.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
							.form-group
								label Nº de horas
								.input-group
									input.form-control(type="number", v-model.number="registro.horasRaw", :disabled="!editable", placeholder="0")
									.input-group-append
										button.btn(
											:class="(registro.tipo_registro === 'consume') ? 'btn-primary' : ''"
											@click="setTipo('consume')"
										) Consumidas
									.input-group-append
										button.btn(
											:class="(registro.tipo_registro === 'acumula') ? 'btn-primary' : ''"
											@click="setTipo('acumula')"
										) Acumuladas
					.form-group.mt-3
						label Descripción
						textarea.form-control(rows="5", :disabled="!editable", placeholder="Describe brevemente en qué se acumulan o consumen las horas", v-model="registro.descripcion")

				.card-footer
					button.btn.btn-primary(
						:disabled="!formOk || !esUltimo"
						@click="guardar"
						v-if="!registro.aprobado || soyLider"
					)
						span.fa.fa-save.mr-2
						| Guardar
					button.btn.btn-danger(
						disabled
						v-if="registro.aprobado && !soyLider"
					) Este registro ya está aprobado, solo lo puede modificar tu jefe de equipo
</template>

<style>
.form-group .vdp-datepicker .input-group > input {
  background-color: white !important;
}


</style>

<script>
import API from '../api.js'
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			registro: {
				ID_registro: null,
				usuario_ID: null,
				infoUsuario: null,
				fecha: null,
				horasRaw: null,
				descripcion: null,
				original_ID: null,
				tipo_registro: null
			},
			historico: [],
			soyLider: false
		}
	},
	created () {
		if (this.$route.params.id !== 'nuevo') {
			this.getRegistro(this.$route.params.id)
		} else {
			this.nuevo()
		}

		API.soyLider()
			.then(res => {
				this.soyLider = res.data.lider
			})
			.catch(e => {
				this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	beforeRouteUpdate (to, form, next) {
		if (to.params.id && to.params.id !== 'nuevo') {
			this.getRegistro(to.params.id)
		} else {
			this.nuevo()
		}
		next()
	},
	computed: {
		formOk () {
			return (this.registro.usuario_ID && this.registro.fecha && (typeof this.registro.horasRaw === 'number') && this.registro.horasRaw > 0 && this.registro.tipo_registro && this.registro.descripcion)
		},
		esUltimo () {
			if (this.historico.length === 0) {
				return true
			}
			return (this.registro.ID_registro === this.historico[this.historico.length - 1].ID_registro)
		},
		editable () {
			if (this.registro.aprobado && !this.soyLider) {
				return false
			}
			if (this.historico.length === 0) {
				return true
			}

			return (this.registro.ID_registro === this.historico[this.historico.length - 1].ID_registro)
		},
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		nuevo () {
			this.registro.ID_registro = null
			this.registro.usuario_ID = null
			this.registro.infoUsuario = null
			this.registro.fecha = null
			this.registro.horasRaw = null
			this.registro.descripcion = null
			this.registro.original_ID = null
			this.registro.tipo_registro = null

			if (!this.soyLider) {
				this.registro.usuario_ID = this.usuario.ID
				this.registro.usuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos
			} else {
				this.registro.usuario_ID = null
				this.registro.usuarioNombre = null
			}
		},
		getRegistro (idRegistro) {
			API.getRegistro(idRegistro)
				.then(res => {
					this.registro = res.data.registro
					this.registro.horasRaw = this.registro.horasRaw < 0 ? -this.registro.horasRaw : this.registro.horasRaw
					this.historico = res.data.historico
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		seleccionaUsuario (ev) {
			this.registro.usuario_ID = ev.data.ID
			this.registro.usuarioNombre = ev.data.nombre + ' ' + ev.data.apellidos
		},
		quitarUsuario () {
			this.registro.usuario_ID = null
			this.registro.usuarioNombre = null
		},
		setTipo (tipo) {
			if (!this.esUltimo) {
				return
			}
			this.registro.tipo_registro = tipo
		},
		guardar () {
			if (!this.soyLider) {
				this.registro.usuario_ID = this.usuario.ID
			}
			API.setRegistro(this.registro)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Horas registradas',
						mensaje: 'Se han registrado las horas correctamente'
					})
					if (this.registro.usuario_ID === this.usuario.ID) {
						this.$router.push('/main/horas-extra/usuario/yo')
					} else {
						this.$router.push('/main/horas-extra/listado')
					}
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/editor/editor.vue